import { useMutation } from '@tanstack/react-query'
import { deleteAccount } from '@/services/api/auth'
import { useAuthStore } from '@/store/authStore'

const DELETE_ACCOUNT_MUTATION_KEY = ['mutation', 'auth', 'deleteAccount'] as const

/**
 * Permanently deletes the account, then clears local auth state via
 * `authStore.logout()`. Not offline-replayable — an irreversible mutation
 * must never queue silently while offline. A wrong confirmation password is
 * a 422 that `DeleteAccountSection` shows inline, so it opts out of the
 * global toast/report.
 */
export function useDeleteAccount() {
  const logout = useAuthStore((s) => s.logout)

  return useMutation({
    mutationKey: DELETE_ACCOUNT_MUTATION_KEY,
    mutationFn: (password: string) => deleteAccount(password),
    meta: { inlineErrorStatuses: [422] },
    onSuccess: () => {
      logout()
    },
  })
}
